const SEMVER_PATTERN = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)/;

const parse = (versao: string | null | undefined): [number, number, number] | null => {
  if (!versao) return null;
  const match = SEMVER_PATTERN.exec(versao);
  if (!match) return null;
  return [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3], 10)];
};

export const versaoMaiorOuIgual = (versao: string | null | undefined, alvo: string): boolean => {
  const v = parse(versao);
  const a = parse(alvo);
  if (!v || !a) return false;

  for (let i = 0; i < 3; i++) {
    if (v[i] !== a[i]) return v[i] > a[i];
  }
  return true;
};

export const VERSAO_PESSOAL_AREAS_ORGANIZACIONAIS = "7.1.0";
